// extracted by mini-css-extract-plugin
export default {"loaderContainer":"PageLoader_loaderContainer__sEBAO","loaderTitle":"PageLoader_loaderTitle__BF2dO"};